import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ABPPhotoConfigService {
  private mediaRequirementsTitle: string[] = [
    'Logo requirements',
    'Cover photo requirements',
    'Photo requirements',
    'Photo Interior requirements',
    'Photo Exterior requirements',
    'Video requirements',
  ];

  private mediaRequirementsDescription = [
    {
      id: 'VIDEO',
      category: 'ADDITIONAL',
      details: [
        'File format: MPEG4/MP4',
        'Duration: Up to 30 seconds long',
        'File size: Up to 75 MB',
        'Resolution: 720p or higher',
      ],
    },
    {
      id: 'PHOTO INTERIOR',
      category: 'PHOTO INTERIOR',
      details: [
        'Photo should be a real photo, not a graphic containing text and other design elements.',
        'Image format: HEIF, JPEG, or PNG',
        'Aspect ratio: 1:1 (square)',
        'Minimum size (pixels): 492 x 492',
        'Maximum size (pixels): 4864 x 4864',
      ],
    },
    {
      id: 'PHOTO',
      category: 'PHOTO',
      details: [
        'Photo should be a real photo, not a graphic containing text and other design elements.',
        'Image format: HEIF, JPEG, or PNG',
        'Aspect ratio: 1:1 (square)',
        'Minimum size (pixels): 492 x 492',
        'Maximum size (pixels): 4864 x 4864',
      ],
    },
    {
      id: 'PHOTO EXTERIOR',
      category: 'PHOTO EXTERIOR',
      details: [
        'Photo should be a real photo, not a graphic containing text and other design elements.',
        'Image format: HEIF, JPEG, or PNG',
        'Aspect ratio: 1:1 (square)',
        'Minimum size (pixels): 492 x 492',
        'Maximum size (pixels): 4864 x 4864',
      ],
    },
    {
      id: 'COVER PHOTO',
      category: 'COVER',
      details: [
        'Photo should be a real photo, not a graphic containing text and other design elements.',
        'Image must have 16:9 aspect ratio. For example,  1600px by 900px.',
        'Minimum 420px width and 270px height.',
        'Minimum size (pixels): 492 x 492',
        'Maximum size (pixels): 4864 x 4864',
      ],
    },
    {
      id: 'LOGO',
      category: 'LOGO',
      details: [
        'Photo should be a real photo, not a graphic containing text and other design elements.',
        'Image must be exactly square.',
        'Minimum 250px width by 250px height.',
        'Minimum size (pixels): 492 x 492',
        'Maximum size (pixels): 4864 x 4864',
      ],
    },
  ];

  public setABPMediaRequirements(category: string) {
    switch (category) {
      case 'LOGO':
        return {
          title: this.mediaRequirementsTitle[0],
          description: this.mediaRequirementsDescription.find((v) => v.id === category).details,
        };
      case 'COVER PHOTO':
        return {
          title: this.mediaRequirementsTitle[1],
          description: this.mediaRequirementsDescription.find((v) => v.id === category).details,
        };
      case 'PHOTO':
        return {
          title: this.mediaRequirementsTitle[2],
          description: this.mediaRequirementsDescription.find((v) => v.id === category).details,
        };
      case 'PHOTO INTERIOR':
        return {
          title: this.mediaRequirementsTitle[3],
          description: this.mediaRequirementsDescription.find((v) => v.id === category).details,
        };
      case 'PHOTO EXTERIOR':
        return {
          title: this.mediaRequirementsTitle[4],
          description: this.mediaRequirementsDescription.find((v) => v.id === category).details,
        };
      case 'VIDEO':
        return {
          title: this.mediaRequirementsTitle[5],
          description: this.mediaRequirementsDescription.find((v) => v.id === category).details,
        };
    }
  }
}
